
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBackward as ObiBackwardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-backward.js';
 
 
 

 
 export const ObiBackward = createComponent({
   react: React,
   tagName: 'obi-backward',
   elementClass: ObiBackwardElement,
   events: {
     
   }
  });
 
 